import { lang } from '@umu/ukit-lang';
/*
 * @Author: zhaihaooran
 * @Date: 2021-07-15 22:00:15
 * @LastEditors: OBKoro1
 * @FilePath: /umu_mobile/src/common/components/@SlidePicker/config.tsx
 */
import React from 'react';
import dayjs from 'dayjs';

export const WEEK_TEXT_MAP = {
    0: lang('日'),
    1: lang('一'),
    2: lang('二'),
    3: lang('三'),
    4: lang('四'),
    5: lang('五'),
    6: lang('六'),
};

export type WeekType = '0' | '1' | '2' | '3' | '4' | '5' | '6';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const TIME_FORMAT_SHOW = 'HH:mm';

/**
 * 结束时间 - 长久有效
 */
export const DATE_INFINITY = '0';

export const DATE_NOW = dayjs().format(DATE_FORMAT);

export enum PICKER_MODE {
    DATE = 'date',
    TIME = 'time',
}

export const MODE_SETTING = {
    [PICKER_MODE.DATE]: {
        format: DATE_FORMAT,
        formatValue: (val: string) => val,
    },
    [PICKER_MODE.TIME]: {
        format: TIME_FORMAT_SHOW,
        formatValue: (val: string) => `2010-05-02 ${val}`,
    },
};

export function renderVal<T>(selectDate: T, placeholder = '', _disabled = false) {
    return (
        <span className="item-right-corner">
            {`${selectDate}` || placeholder}
            <i className="iconfont icon-arrow-right"></i>
        </span>
    );
}
